import type { GetPolicyStateParams, GetPolicyStateResponse } from '../model/Policy.types';
import { serializeToFormDataDefaultRequestKeys } from '@/app/plugins/http/http.utils';
import { BaseService, defineApi } from '@/shared/api';

class PolicyService extends BaseService {
  /** https://qicbizdev.atlassian.net/wiki/spaces/QB/pages/479920147/WEB+Q+Get+policy+state */
  async getPolicyState(params: GetPolicyStateParams): Promise<GetPolicyStateResponse> {
    const payload = serializeToFormDataDefaultRequestKeys(params);
    return await this.post('/getpolicystate', payload);
  }
}

export const usePolicyService = defineApi(PolicyService);
